import { Phone, Mail, MapPin } from "lucide-react";
import { COMPANY, SERVICES } from "@/data";

export const Footer = () => {
  return (
    <footer className="bg-navy-deep text-zinc-400 border-t border-white/10" data-testid="main-footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16 grid gap-10 md:grid-cols-4">
        <div className="md:col-span-2">
          <img src={COMPANY.logoWhite} alt="NDNS Elektro Katowice" className="h-12 w-auto" />
          <p className="mt-5 text-sm leading-relaxed max-w-md">
            Kompleksowe instalacje elektryczne i sieci słaboprądowe. Licencjonowany elektryk
            z uprawnieniami SEP działający w Katowicach, na Górnym Śląsku i w Małopolsce.
          </p>
        </div>

        <div>
          <h3 className="font-heading font-bold text-white text-sm tracking-[0.15em] uppercase">Usługi</h3>
          <ul className="mt-4 space-y-2 text-sm">
            {SERVICES.map((s) => (
              <li key={s.id}>
                <a href={`#${s.id}`} className="hover:text-magenta-light transition-colors">
                  {s.seo}
                </a>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h3 className="font-heading font-bold text-white text-sm tracking-[0.15em] uppercase">Kontakt</h3>
          <ul className="mt-4 space-y-3 text-sm">
            <li>
              <a href={COMPANY.phoneHref} className="inline-flex items-center gap-2 hover:text-magenta-light transition-colors">
                <Phone className="w-4 h-4" /> {COMPANY.phone}
              </a>
            </li>
            <li>
              <a href={`mailto:${COMPANY.email}`} className="inline-flex items-center gap-2 hover:text-magenta-light transition-colors">
                <Mail className="w-4 h-4" /> {COMPANY.email}
              </a>
            </li>
            <li className="flex items-start gap-2 text-zinc-400">
              <MapPin className="w-4 h-4 mt-0.5 shrink-0 text-magenta-light" />
              <span>{COMPANY.address}<br />{COMPANY.postal}</span>
            </li>
          </ul>

          <h3 className="mt-8 font-heading font-bold text-white text-sm tracking-[0.15em] uppercase">Dane do faktury</h3>
          <div className="mt-3 text-sm text-zinc-400 leading-relaxed" data-testid="footer-invoice-data">
            {COMPANY.legalName}<br />
            {COMPANY.address}, {COMPANY.postal}<br />
            NIP: {COMPANY.nip}
          </div>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 py-6 flex flex-col sm:flex-row items-center justify-between gap-2 text-xs text-zinc-500">
          <span>© {new Date().getFullYear()} NDNS Elektro. Wszelkie prawa zastrzeżone.</span>
          <span>Instalacje elektryczne · Pomiary SEP · CCTV · Smart Home</span>
        </div>
      </div>
    </footer>
  );
};
